import React, { useState, useEffect } from 'react'
import '../styles/header.css';
import { Link } from 'react-router-dom'
import { config } from '../server'

const address = config.url.API_URL
const Members = (props) => {
    const spaceName = props.match.params.spaceName
    const [members, setMembers] = useState([])

    useEffect(() => {
        let mounted = true
        const getMembers = async () => {
            const res = await fetch(`${address}/api/${spaceName}/members`)
            const data = await res.json()
            //console.log(data)
            if(mounted) {
                setMembers(data.allMembers)
            }
        }
        getMembers()
        return () =>  mounted = false
    }, [spaceName])
    return (
    <div>
    <div className="hero is-primary">
			<div className="hero-body">
				<div className="container">
					<div className="level-left">
						<h1 className="title">
                            {spaceName}
						</h1>
					</div>
					<div className="level-left">
						<h2 className="subtitle">
                            description
						</h2>
					</div>
				</div>
			</div>
		</div>
        <div className="level">
            <div className="level-left">
                Reminders
            </div>
            <div className="level-item">
            <Link className="link" to={ {
              pathname: `/space/${spaceName}/chat`}}>Chat</Link>            
            </div>
            <div className="level-right">
            <Link className="link" to={ {
              pathname: `/space/${spaceName}/members`}}>Members</Link>   
            </div>
        </div>
        <div>
          <div className="level-item">
           Members
          </div>
    </div>



    <div className="level-item">
    <div className="column is-6">
      {members.map((member,i) => (
        <ul key={i}>
        <li key={i}>
          <div key={i}>
          <div key={i} className="card">
            <header key={i+1} className="card-header">
              <p className="card-header-title">
                {member.requestingUser}
              </p>
        </header>
      </div>
          </div>
        </li>
      </ul>
      ))}
    </div>
    </div>





    </div>
    
    )
}

export default Members